<template>
    <div class="message-content fr-view"></div>
</template>

<script lang="ts">
    import {createComponent} from '@/library/utils';
    import {type App, defineComponent, h} from 'vue';
    import {Component, Prop, Vue} from 'vue-facing-decorator';
    import TopMessageHandler from '../library/topMessageHandler';
    import {errorHandler} from '@/utils/portuna';
    import PersonBoxUser from './PersonBoxUser.vue';

    let vueApp: App<Element>;

    export function setMentionVueApp(app: App<Element>)
    {
        vueApp = app;
    }

    @Component({
        name: 'UserContent',
    })
    export default class UserContent extends Vue
    {
        @Prop({
            type: Boolean,
            default: false,
            required: false,
        }) disableUserMention: boolean;

        @Prop({
            type: Boolean,
            default: false,
            required: false,
        }) enableTaskRemind: boolean;

        _Apps: App<Element>[] = [];

        _Elements: Element[] = [];

        mounted()
        {
            if (!this.disableUserMention)
            {
                for (let mention of this.$el.getElementsByClassName('user-mention'))
                {
                    let tooltipRoute = mention.getAttribute('data-tooltip-route');
                    if (!tooltipRoute)
                    {
                        continue;
                    }

                    let userId: number = parseInt(tooltipRoute.split('/').pop() as string);
                    if (!userId || !mention.parentNode)
                    {
                        continue;
                    }

                    let instance = defineComponent({
                        name: 'UserContentPersonBoxWrapper',
                        render()
                        {
                            return h(PersonBoxUser, {
                                    props: {
                                        nameOnly: true,
                                        id: userId,
                                        tag: 'span',
                                    },
                                },
                                {
                                    name: (props: any) =>
                                    {
                                        return [
                                            h('span', {class: 'user-mention'}, `${props.username}`),
                                        ];
                                    },
                                },
                            );
                        },
                    });

                    const element = document.createElement('span');
                    this._Elements.push(element);

                    mention.parentNode!.insertBefore(element, mention);

                    const {app} = createComponent({
                        app: vueApp,
                        component: instance,
                        props: {
                            nameOnly: true,
                            id: userId,
                            tag: 'span',
                        },
                        el: element,
                    });

                    this._Apps.push(app);

                    mention.parentNode!.removeChild(mention);
                }
            }

            if (this.enableTaskRemind)
            {
                const reminderValue = this.$el.querySelector('#reminder-offset') as HTMLInputElement;
                const reminderAdd   = this.$el.querySelector('.reminder-add');
                if (reminderValue && reminderAdd)
                {
                    reminderAdd.addEventListener('click', () =>
                    {
                        const assignmentId = reminderAdd.getAttribute('data-assignment-id');
                        const namespace    = reminderAdd.getAttribute('data-namespace');
                        const start        = reminderAdd.getAttribute('data-start');
                        const offset       = parseInt(reminderValue.value);

                        if (assignmentId && offset && namespace)
                        {
                            // @todo: update
                            this.axios.post(
                                '/task/entry/add-reminder',
                                {
                                    offset,
                                    assignmentId,
                                    namespace,
                                    start,
                                },
                            )
                            .then(({data: response}) =>
                            {
                                if (response.success)
                                {
                                    TopMessageHandler.success(response.message);
                                }
                                else
                                {
                                    TopMessageHandler.error(response.message);
                                }
                            }).catch(errorHandler);
                        }
                    });
                }
            }
        }

        beforeUnmount()
        {
            for (let app of this._Apps)
            {
                app.unmount();
            }

            this._Apps = [];

            for (let element of this._Elements)
            {
                element.remove();
            }

            this._Elements = [];
        }
    }
</script>